(() => {
  if (window.gssShoppingReady) return;
  window.gssShoppingReady = true;
  const root = window.Shopify?.routes?.root || '/';
  let dialog, trigger, request, toast, timer;
  function getDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'gss-quick-dialog';
    dialog.setAttribute('aria-label', 'Product quick view');
    dialog.innerHTML = '<button type="button" class="gss-quick-close" aria-label="Close product details">×</button><div data-gss-quick-content></div>';
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    dialog.addEventListener('close', () => { request?.abort(); document.documentElement.classList.remove('gss-quick-open'); trigger?.focus(); });
    document.body.append(dialog);
    return dialog;
  }
  document.addEventListener('click', async event => {
    const link = event.target.closest('.gss-card [data-gss-details], .gss-card .gss-details');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); event.stopImmediatePropagation();
    trigger = link;
    const modal = getDialog();
    request?.abort(); const controller = request = new AbortController();
    const content = modal.querySelector('[data-gss-quick-content]');
    content.innerHTML = '<p class="gss-quick-loading" role="status">Loading product…</p>';
    if (!modal.open) modal.showModal();
    document.documentElement.classList.add('gss-quick-open');
    try {
      const url = new URL(link.href || link.dataset.gssDetailsUrl, location.origin);
      url.searchParams.set('view', 'gemstop-supermarket-details');
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('Unable to load this product. Please try again.');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const product = doc.querySelector('[data-gss-product-details]');
      if (!product) throw new Error('Unable to load this product. Please try again.');
      if (request === controller && modal.open) content.replaceChildren(product);
    } catch (error) { if (error.name !== 'AbortError' && request === controller) content.textContent = error.message; }
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-gss-quantity-step]');
    if (!button) return;
    const input = button.closest('.gss-quantity-stepper').querySelector('input');
    const step = Number(button.dataset.gssQuantityStep);
    if (step > 0) input.stepUp(); else input.stepDown();
    input.dispatchEvent(new Event('input', {bubbles:true}));
    input.dispatchEvent(new Event('change', {bubbles:true}));
  });
  document.addEventListener('input', event => {
    if (!event.target.matches('.gss-quantity-stepper input')) return;
    event.target.closest('.gss-quantity-stepper').querySelector('[data-gss-quantity-step="-1"]').disabled = Number(event.target.value) <= Number(event.target.min || 1);
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-gss-quick-variant]')) return;
    event.target.closest('[data-gss-product-details]').querySelector('[data-gss-quick-price]').textContent = event.target.selectedOptions[0].dataset.price;
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]') || !form.closest('.gss-card, [data-gss-product-details]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (form.dataset.adding) return;
    const button = form.querySelector('[type="submit"]');
    if (!button || button.disabled) return;
    form.dataset.adding = 'true'; button.disabled = true; button.setAttribute('aria-busy','true');
    const original = button.textContent; button.textContent = 'Adding…';
    let message = form.querySelector('[data-gss-form-status]');
    if (!message) { message = document.createElement('p'); message.dataset.gssFormStatus = ''; message.setAttribute('role','status'); message.className = 'gss-quick-message'; form.append(message); }
    message.textContent = '';
    try {
      const response = await fetch(root + 'cart/add.js', { method:'POST', headers:{Accept:'application/json'}, body:new FormData(form) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'This item could not be added. Please try again.');
      button.textContent = '✓ Added'; button.classList.add('gss-added');
      message.textContent = 'Added to your cart';
      if (!toast) { toast = document.createElement('div'); toast.className = 'gss-cart-toast'; toast.setAttribute('role','status'); toast.innerHTML = '<span>✓ Added to cart</span><a>View cart</a><button type="button" aria-label="Dismiss notification">×</button>'; toast.querySelector('a').href = root+'cart'; toast.querySelector('button').onclick = () => toast.classList.remove('is-visible'); }
      const host = form.closest('dialog') || document.body;
      host.append(toast); toast.classList.add('is-visible'); clearTimeout(timer); timer = setTimeout(()=>toast.classList.remove('is-visible'),6000);
      try { const cart = await (await fetch(root+'cart.js')).json(); document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=cart.item_count;el.setAttribute('data-cart-count',cart.item_count);}); } catch (_) {}
    } catch (error) { message.textContent = error.message || 'Could not confirm the addition. Check your cart before trying again.'; }
    finally { button.removeAttribute('aria-busy'); setTimeout(()=>{button.textContent=original;button.disabled=false;button.classList.remove('gss-added');delete form.dataset.adding;},1200); }
  }, true);
})();
